import React, {Fragment, useState, useEffect} from 'react';
import RNUFormService from "../../../../services/RNUFormService";
import NumberFormat from 'react-number-format';
import Color from "color";

const Template1BCadastral = (props) => {

    const rnuFormService = new RNUFormService()
    const [items, setItems]= useState([])
    const fetchData = rnuFormService.getData('parcelles')



    useEffect(()=>{
        (fetchData)?setItems(fetchData):null;

    },[fetchData])


    return (
        <div className="ue-section ue-cadastral">
            <table className="ue-form-table-base">
                <thead style={(props.primColor)?{"backgroundColor": Color(props.primColor).alpha(0.5)}:{}}>
                <tr className="text-center">
                    <th>Dept.</th>
                    <th>Commune</th>
                    <th colSpan="4">Parcelle(s)</th>
                </tr>
                </thead>
                <tbody>
                <tr className="text-center">
                    <td>{(items && items.length>0)?items[0].id.substring(0, 2):null}</td>
                    <td>{(items && items.length>0)?items[0].commune:null}</td>
                    <td colSpan="4" style={{"verticalAlign":"middle","fontSize":"0.7rem","lineHeight":"0.78rem" }}>
                        {(items && items.length>0)?
                            items.map((item,index)=>{

                                let separator =(index>0)?', ':'';

                                return `${separator} ${item.id.substr(- 6)} (${item.contenance}) `
                            })
                            :null
                        }
                    </td>
                </tr>
                <tr className="text-right">
                    <th colSpan="2" rowSpan="3">Total :</th>
                    <th>Nombre de parcelles</th>
                    <td>{items.length}</td>
                    <th>Bati</th>
                    <td>{(_.sumBy(items, (item) => Number(item.surface_bati ))>=1)?'oui':'non'}</td>
                </tr>
                <tr className="text-right">
                    <th> Contenance (ca)</th>
                    <td>
                        <NumberFormat value={Math.round(_.sumBy(items, (item) => Number(item.contenance)))} displayType={'text'} thousandSeparator={' '}  />
                    </td>
                    <th>Surface bati sols(%)</th>
                    <td>
                        <NumberFormat value={Math.round(_.sumBy(items, (item) => Number(item.pourcentage_bati)))} displayType={'text'} thousandSeparator={' '}  />

                    </td>
                </tr>
                <tr className="text-right">
                    <th>Surface (m<sup>2</sup>)</th>
                    <td>
                        <NumberFormat value={Math.round(_.sumBy(items, (item) => Number(item.surface)))} displayType={'text'} thousandSeparator={' '}  />
                    </td>
                    <th>Surface bati sol(m<sup>2</sup>)</th>
                    <td>
                        <NumberFormat value={Math.round(_.sumBy(items, (item) => Number(item.surface_bati)))} displayType={'text'} thousandSeparator={' '}  />
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    );
};

export default Template1BCadastral;
